import { func } from 'prop-types';
import { Component } from 'react';

import api from 'atg/api/API';
import LinkDialog from 'shared/components/dialog/LinkDialog';
import { getText } from 'shared/utils/Text';
import { toAbsoluteUrl } from 'shared/utils/urls';

export default class ReportDialogContainer extends Component {
  static propTypes = {
    closeHandler: func.isRequired,
  };

  state = {
    pdfPath: null,
  };

  mounted = false;

  componentDidMount() {
    this.mounted = true;
    api.createSystemReportPDF(pdfPath => {
      if (this.mounted) {
        this.setState({
          pdfPath,
        });
      }
    });
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    const { closeHandler } = this.props;
    const { pdfPath } = this.state;

    let url;
    if (pdfPath) {
      url = toAbsoluteUrl(pdfPath);
    }

    return (
      <LinkDialog
        closeHandler={closeHandler}
        title={getText('dialog-html-export-title-report')}
        body={getText('dialog-html-export-text-report')}
        url={url}
        isPdf
        mailBody={getText('dialog-html-export-email-body-report', url)}
      />
    );
  }
}
